module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.post) ? _c('article', {
    key: ((_vm.post.uid) + "-article"),
    staticClass: "post"
  }, [_c('article-nav', {
    class: _vm.toCssName(_vm.category),
    attrs: {
      "prevPost": _vm.getPrevPost(_vm.post),
      "nextPost": _vm.getNextPost(_vm.post)
    }
  }), _vm._v(" "), _c('article-header', {
    class: _vm.toCssName(_vm.category),
    attrs: {
      "post": _vm.post
    }
  }), _vm._v(" "), _c('main', {
    class: _vm.toCssName(_vm.category)
  }, [_c('content-share', {
    attrs: {
      "title": _vm.title,
      "position": "top"
    }
  }), _vm._v(" "), _vm._l((this.post.data.body), function(contentBlock) {
    return _c('div', {
      class: ("post-content post-content--" + (contentBlock.slice_type))
    }, [_c(_vm.getContentBlock(contentBlock.slice_type), {
      tag: "component",
      attrs: {
        "content": contentBlock
      }
    })], 1)
  }), _vm._v(" "), _c('content-share', {
    attrs: {
      "title": _vm.title,
      "position": "bottom"
    }
  })], 2), _vm._v(" "), _c('related-posts', {
    attrs: {
      "prevPost": _vm.getPrevPost(_vm.post),
      "nextPost": _vm.getNextPost(_vm.post)
    }
  })], 1) : _c('article', {
    key: "false"
  }, [_c('loading-animation')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2d0632a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Post.vue
// module id = 87
// module chunks = 0